import React, { useEffect, useState } from 'react'
import "./AdminDashboardScreensTable.css"
import { getScreenData } from '../../../../services/getScreenData';
import { updateScreenById } from '../../../../services/updateScreenById';
import { useSelector } from 'react-redux'
import { getToken } from '../../../../features/token/tokenSaver';
function formatScreenCost(value) {
    const n = Number(value);
    const amount = Number.isFinite(n) && n > 0 ? n : 59;
    return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(amount);
}

function truncateMeta(value, maxLen = 48) {
    if (value === undefined || value === null) {
        return '';
    }
    const s = String(value).trim();
    if (!s) {
        return '';
    }
    return s.length > maxLen ? `${s.slice(0, maxLen - 1)}…` : s;
}

export default function AdminDashboardScreensTable(props) {
    const [page, setPage] = useState(0);
    const [screenData, setScreenData] = useState([]);
    const [forwardDisabled, setForwardDisabled] = useState(false);
    const [max, setMax] = useState(1);
    const [updatingScreens, setUpdatingScreens] = useState({});
    const [rowFeedback, setRowFeedback] = useState({ type: '', message: '' });
    const token = useSelector(getToken)

    useEffect(() => {
            populateTable(true);

      return () => {
        
      }
    }, [])
    function populateTable(forward = true) {
        setScreenData([]);

        const nextPage = forward ? page + 1 : page - 1;
        getScreenData(token, nextPage, 10).then(response => {
            setScreenData(response.data.screens);
            if (forward) {
            setPage(page + 1);}
            else {
                setPage(page - 1);
            }
            setMax(Math.ceil(response.data.count / 10))
            if (Math.ceil(response.data.count / 10) <= nextPage) {
                setForwardDisabled(true)
            }
            else {
                setForwardDisabled(false)

            }
        }).catch(e => {
            console.log(e)
        });

    }

    function extractBackendError(error) {
        return error?.response?.data?.message
            || error?.response?.data?.error
            || error?.message
            || 'Unable to queue screen update right now.';
    }

    async function handleUpdateScreen(event, screenId) {
        event.stopPropagation();

        if (updatingScreens[screenId]) {
            return;
        }

        setUpdatingScreens((previous) => ({ ...previous, [screenId]: true }));
        setRowFeedback({ type: '', message: '' });

        try {
            await updateScreenById(token, screenId);
            setRowFeedback({ type: 'success', message: `Screen #${screenId} queued for update.` });
        } catch (error) {
            setRowFeedback({ type: 'error', message: extractBackendError(error) });
        } finally {
            setUpdatingScreens((previous) => {
                const next = { ...previous };
                delete next[screenId];
                return next;
            });
        }
    }


    return (
        <div className='adminDashboardScreensTableContainer'>
            {rowFeedback.message && (
                <div className={`adminScreensRowFeedback ${rowFeedback.type === 'error' ? 'error' : 'success'}`}>
                    {rowFeedback.message}
                </div>
            )}
            {props.data && <table className='adminDashboardScreensTable'>
                <thead>
                    <tr>
                        <th>Screen Id</th>
                        <th>Owner Id</th>
                        <th>Brand</th>
                        <th>Location</th>
                        <th>Screen cost</th>
                        <th>Active</th>
                        <th>Last Active</th>
                        <th>Action</th>
                    </tr>
                </thead>
                <tbody>
                    {props.data.map(screen => {
                        const locRaw = screen.LocationDescription || screen.locationDescription || '';
                        const locDisplay = truncateMeta(locRaw, 56);
                        return <tr className='adminScreenRow' key={screen.ScreenId} onClick={() => {
                            props.screenDetails(screen.ScreenId);

                        }}>
                            <td>{screen.ScreenId}</td>
                            <td>{screen.OwnerUserId}</td>
                            <td title={screen.Brand || screen.brand || ''}>{truncateMeta(screen.Brand || screen.brand || '', 32) || '—'}</td>
                            <td title={locRaw}>{locDisplay || '—'}</td>
                            <td>{formatScreenCost(screen.ScreenCost ?? screen.screenCost)}</td>
                            <td ><span className={screen.Active === "true" && 'activeStatus' || 'inactiveStatus'}>{screen.Active === "true" && 'Active' || 'Inactive'}</span></td>
                            <td>{new Date(screen.LastActive).toLocaleDateString()}</td>
                            <td>
                                <button
                                    className='screenRowUpdateButton'
                                    disabled={!!updatingScreens[screen.ScreenId]}
                                    onClick={(event) => handleUpdateScreen(event, screen.ScreenId)}
                                >
                                    {updatingScreens[screen.ScreenId] ? 'Queueing...' : 'Update Screen'}
                                </button>
                            </td>
                        </tr>
                    })}
                </tbody>
            </table>}
            {!props.data && <table className='adminDashboardScreensTable'>
            <thead>
                <tr>
                    <th>Screen Id</th>
                    <th>Owner Id</th>
                    <th>Brand</th>
                    <th>Location</th>
                    <th>Screen cost</th>
                    <th>Active</th>
                    <th>Last Active</th>
                    <th>Action</th>
               </tr>
            </thead>
            <tbody>
                   { screenData.map(screen => {
                       const locRaw = screen.LocationDescription || screen.locationDescription || '';
                       const locDisplay = truncateMeta(locRaw, 56);
                       return <tr className='adminScreenRow' key={screen.ScreenId} onClick={() => {
                           props.screenDetails(screen.ScreenId);

                       }}>
                           <td>{screen.ScreenId}</td>
                           <td>{screen.OwnerUserId}</td>
                           <td title={screen.Brand || screen.brand || ''}>{truncateMeta(screen.Brand || screen.brand || '', 32) || '—'}</td>
                          <td title={locRaw}>{locDisplay || '—'}</td>
                          <td>{formatScreenCost(screen.ScreenCost ?? screen.screenCost)}</td>
                          <td ><span className={screen.Active === "true" && 'activeStatus' || 'inactiveStatus'}>{screen.Active === "true" && 'Active' || 'Inactive'}</span></td>
                          <td>{new Date(screen.LastActive).toLocaleDateString()}</td>
                          <td>
                              <button
                                  className='screenRowUpdateButton'
                                  disabled={!!updatingScreens[screen.ScreenId]}
                                  onClick={(event) => handleUpdateScreen(event, screen.ScreenId)}
                              >
                                  {updatingScreens[screen.ScreenId] ? 'Queueing...' : 'Update Screen'}
                              </button>
                          </td>
                      </tr>
               })}
            </tbody>
            </table>}
            <div className='tablePaginationContainer'>
                <span className='paginationIcon' onClick={() => {
                   
                    populateTable(false);
                }} disabled={page <= 1}>{'<'}</span>
                <input className='page' max={max} min={1} type={"number"} onChange={async (e) => {
                                    const requestedPage = Number(e.nativeEvent.target.value);
                                    if (!requestedPage || requestedPage < 1) {
                                        return;
                                    }
                                    setPage(requestedPage - 1);
                                    getScreenData(token, requestedPage, 10).then(response => {
                                        setScreenData(response.data.screens);
                                    }).catch((error) => {
                                        console.error(error);
                                    });
                }} placeholder={page}/>
                <span className='paginationIcon' onClick={() => {
                    populateTable(true);
                }} disabled={forwardDisabled}>{'>'}</span>
            </div>
        </div>    )
}
